import { live_video_alertService } from '../_services';

const state = { onRequest: false, live_video_alert: [] };

const actions = {
    get_data({ dispatch, commit }, data) {
        commit('request');

        live_video_alertService.get_data(data)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    clear_data({ commit }) {
        commit('clear_data');
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  live_video_alert: state => {
    return state.live_video_alert
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.live_video_alert = [];
    },
    success(state) {
      state.onRequest = false;
    },
    clear_data(state) {
      state.onRequest = false;
      state.live_video_alert = [];
    },
    success_data(state, data) {
      state.onRequest = false;
      state.live_video_alert = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const live_video_alerts = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
